import { Box } from '@mui/material'
import { ReactNode } from 'react'
import { COLORS, MAX_WIDTH } from '../../constants'

const BACKGROUNDS = {
    white: COLORS.white,
    light: COLORS.light,
    dark: COLORS.black,
    darker: COLORS.blackSecondary,
}

type SectionProps = {
    children: ReactNode
    tone?: keyof typeof BACKGROUNDS
    id?: string
    tight?: boolean
}

export function Container({ children }: { children: ReactNode }) {
    return <Box sx={{ maxWidth: MAX_WIDTH, mx: 'auto', px: { xs: 2.5, sm: 4 } }}>{children}</Box>
}

function Section({ children, tone = 'white', id, tight }: SectionProps) {
    const dark = tone === 'dark' || tone === 'darker'
    return (
        <Box
            component="section"
            id={id}
            sx={{
                backgroundColor: BACKGROUNDS[tone],
                color: dark ? COLORS.white : COLORS.black,
                py: tight ? { xs: 6, md: 8 } : { xs: 8, md: 12 },
                scrollMarginTop: 72,
            }}
        >
            <Container>{children}</Container>
        </Box>
    )
}

export default Section
